import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AuthenticationService } from '../_services/authentication.service';
import { RoleStateService } from '../_services/role-state.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor(
    private authService: AuthenticationService,
    private router: Router,
    private roleStateService: RoleStateService
  ) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | boolean {
    const publicRoutes = ['login', 'forgot-password'];
    // const urlSegments = state.url.split('/');
    const urlSegments = state.url.split('?')[0].split('/');

    if (publicRoutes.includes(urlSegments[1])) {
      return true;
    }

    if (!this.authService.isAuthenticated()) {
      this.router.navigate(['login']);
      return false;
    }

    if (!this.roleStateService.isRolesLoaded) {
      const userId = localStorage.getItem('id');
      if (!userId) {
        return true;
      }
      return this.roleStateService.loadRoles(userId).pipe(
        map(() => this.checkPermissions(this.roleStateService.roles, urlSegments))
      );
    }

    return this.checkPermissions(this.roleStateService.roles, urlSegments);
  }

  private checkPermissions(roles: any[], urlSegments: string[]): boolean {
    const currentModule = urlSegments.length > 2 ? urlSegments[2] : null;
    const currentFunction = urlSegments.length > 3 ? urlSegments[3] : null;

    if (currentModule && !this.hasModulePermission(currentModule, roles)) {
      if (currentModule === 'profile' || currentModule === 'helpdesk' || currentModule === 'tax-form' ||
        currentModule === 'activity' || currentModule === 'user-manual' || currentModule === 'deploy') {
        return true;
      }
      this.router.navigate(['forbidden']);
      return false;
    }

    if (currentFunction && !this.hasFunctionPermission(currentModule, currentFunction, roles)) {
      if (currentFunction.includes('edit-employee') || currentFunction.includes('add-employee') ||
        currentFunction.includes('view-profile') || currentFunction.includes('raise-ticket') ||
        currentFunction.includes('mid-year-review') ||
        currentFunction.includes('manager-review')) {
        return true;
      }
      this.router.navigate(['forbidden']);
      return false;
    }

    return true;
  }

  private hasModulePermission(url: string, roles: any[]): boolean {
    return roles.some((mod: any) => url.includes(mod.moduleUrl));
  }

  private hasFunctionPermission(module: string | null, func: string, roles: any[]): boolean {
    if (!module) return false;
    return roles.some((role: any) =>
      role.moduleUrl === module &&
      role.functions?.some((f: any) => f.functionUrl?.includes(func))
    );
  }
}